export const FormatDate = (newDate) => {
  var a = new Date(parseInt(newDate));
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear().toString().substr(-2);
  var month = months[a.getMonth()];
  let date = a.getDate();
  var time = a.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

  var dateFormat = date + " " + month + " " + year;

  return dateFormat + " - " + time;
};


export const FormatTimeOnly = (FormateDate) => {
  var a = new Date(parseInt(FormateDate));
  var time = a.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  return  time;
};


export const FormatDateOnly = (FormateDate) => {
  var a = new Date(parseInt(FormateDate));
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var yearName = a.getFullYear().toString().substr(-2);
  var monthName = monthNames[a.getMonth()]; // Subtract 1 since month numbers are zero-based
  let date = a.getDate();
  var formattedDate = date > 9 ? date : "0"+date + " " + monthName + " " + yearName;
  return formattedDate;
};
